import { mapObjectiveTextToId } from './objectivesService';
import { mapPlanTextToId } from './plansService';

export interface MappingResult {
  objectiveId: string;
  planId: string;
}

export async function mapSelectionToIds(
  objectiveText: string,
  planText: string
): Promise<MappingResult> {
  const [objectiveId, planId] = await Promise.all([
    mapObjectiveTextToId(objectiveText),
    mapPlanTextToId(planText)
  ]);

  return { objectiveId, planId };
}

export function getObjectiveDisplayName(objectiveId: string): string {
  switch (objectiveId) {
    case 'general-360':
      return 'Complete Evaluation';
    case 'leadership-edge':
      return 'Leadership Edge';
    case 'career-accelerator':
      return 'Career Accelerator';
    case 'collaboration-genius':
      return 'Collaboration Genius';
    default:
      return 'Unknown Objective';
  }
}

export function getPlanDisplayName(planId: string): string {
  switch (planId) {
    case 'basic':
      return 'Complete Evaluation';
    case 'followup':
      return 'Complete Evaluation + Follow-up';
    case 'interview':
      return 'Complete Evaluation + Interviews';
    default:
      return 'Unknown Plan';
  }
}